import { PageLoading } from 'components/loading'
import { useAtividadeColetivaGruposVisualizarQuery } from 'graphql/hooks.generated'
import React from 'react'
import { Redirect, useParams } from 'react-router'

import { AtividadeColetivaGruposVisualizarView } from './AtividadeColetivaGruposVisualizarView'

interface AtividadeColetivaGruposViewParams {
  atividadeColetivaGrupoId: ID
}

export const AtividadeColetivaGruposView = () => {
  const { atividadeColetivaGrupoId } = useParams<AtividadeColetivaGruposViewParams>()

  const {
    data: { grupoParticipanteAtividadeColetiva },
    loading,
    refetch,
  } = useAtividadeColetivaGruposVisualizarQuery({
    variables: { atividadeColetivaGrupoId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!grupoParticipanteAtividadeColetiva) {
    return <Redirect to='/404' />
  } else {
    return (
      <AtividadeColetivaGruposVisualizarView
        atividadeColetivaGrupo={grupoParticipanteAtividadeColetiva}
        refetch={refetch}
      />
    )
  }
}
